import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { useRouter, useRoute } from "vue-router";
import { onMounted, onUnmounted, getCurrentInstance, reactive } from "vue";
import { ElMessage } from "element-plus";
import { phoneDesc, isPhoneNumber, EncryptName } from "../util/index";
import { useMainStore } from "../pinia/main";

import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message-box/style/css';
export default {
  name: "Login",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    onMounted(() => {
      generateCaptcha();
    });
    onUnmounted(() => {
      clearInterval(data.timer);
    });
    let data = reactive({
      imgList: [new URL("../assets/imgs/login_imgs/11.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/4.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/12.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/14.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/8.webp", import.meta.url).href],
      imgList1: [new URL("../assets/imgs/login_imgs/5.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/3.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/18.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/19.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/9.webp", import.meta.url).href],
      imgList2: [new URL("../assets/imgs/login_imgs/1.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/7.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/10.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/14.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/17.webp", import.meta.url).href],
      imgList3: [new URL("../assets/imgs/login_imgs/12.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/5.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/2.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/16.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/13.webp", import.meta.url).href],
      imgList4: [new URL("../assets/imgs/login_imgs/7.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/18.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/15.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/3.webp", import.meta.url).href, new URL("../assets/imgs/login_imgs/6.webp", import.meta.url).href],
      protocolUrl: "",
      validation: "",
      protocolVisible: false,
      tabs: ["验证码登录", "密码登录"],
      tabsIndex: 0,
      isReadProtocol1: false,
      phone: "",
      //手机号码
      code: "",
      //验证码
      second: 0,
      //再次发送验证码间隔
      timer: null,
      //定时器
      codeLoading: false,
      loginType: 1,
      //登录方式 1->验证码 2->密码
      captcha: {
        base: "",
        captchaId: 0
      }
    });

    //生成图像验证码
    const generateCaptcha = async () => {
      var res = await globalProperties.$api.generateCaptcha();
      data.captcha = res;
    };

    //设置定时器
    const setTimer = () => {
      data.second = 60;
      data.timer = setInterval(() => {
        data.second--;
        if (!data.second) {
          clearInterval(data.timer);
        }
      }, 1000);
    };

    //获取验证码
    const sendCode = async () => {
      if (data.second) return;
      if (isPhoneNumber(data.phone.trim())) {
        data.codeLoading = true;
        setTimer();
        var res = await globalProperties.$api.sendLoginCode({
          phone: data.phone.trim(),
          captchaId: data.captcha.captchaId,
          validation: data.validation
        });
        if (res) {
          data.codeLoading = false;
          ElMessage({
            message: "验证码已发送",
            type: "success"
          });
        }
      } else {
        ElMessage({
          message: "请输入有效手机号",
          type: "warning"
        });
      }
    };

    //验证
    const verify = () => {
      if (!isPhoneNumber(data.phone.trim())) {
        ElMessage({
          message: "请输入有效手机号",
          type: "warning"
        });
        return false;
      }
      if (!data.validation && data.loginType == 1) {
        ElMessage({
          message: "请输入图形验证码",
          type: "warning"
        });
        return false;
      }
      if (data.code.length != 6 && data.loginType == 1) {
        ElMessage({
          message: "请输入验证码",
          type: "warning"
        });
        return false;
      }
      if (!data.password && data.loginType == 2) {
        ElMessage({
          message: "请输入登录密码",
          type: "warning"
        });
        return false;
      }
      if (!data.isReadProtocol1) {
        ElMessageBox.confirm("已阅读并同意《用户注册协议》《用户隐私政策》", "", {
          confirmButtonText: "确定，并登录",
          cancelButtonText: "取消",
          showClose: false
        }).then(() => {
          goLogin();
        }).catch(() => {});
        return false;
      }
      return true;
    };

    //去登录
    const goLogin = async () => {
      let params = {
        phoneNumber: data.phone,
        loginType: data.loginType,
        password: data.loginType == 1 ? data.code : data.password
      };
      var res = await globalProperties.$api.login(params);
      await mainStore.setUserInfo(res);
      //用户类型 0->未设定 1->托运人 2->承运人
      if (!res.userType) {
        await globalProperties.$api.settingCustomerType(1);
        res.userType = 1;
      }
      await mainStore.setUserInfo(res);
      router.replace("/layout");
      ElMessage({
        message: "欢迎使用九运易合（企业端）",
        type: "success"
      });
    };

    //登录
    const login = async () => {
      if (verify()) {
        goLogin();
      }
    };
    //设置是否读了协议
    const setIsReadProtocol = (value, keyName) => {
      data[keyName] = value;
    };
    const changeTabIndex = index => {
      data.loginType = index ? 2 : 1;
      data.tabsIndex = index;
    };
    const setProtocolUrl = url => {
      data.protocolVisible = true;
      data.protocolUrl = url;
    };
    return {
      data,
      login,
      setProtocolUrl,
      setIsReadProtocol,
      sendCode,
      mainStore,
      generateCaptcha,
      changeTabIndex
    };
  }
};